import classNames from 'classnames'

import type { ChangeEvent, ReactElement, ReactNode } from 'react'

import CheckboxInput from '../../CheckboxInput'

import Label from '~/components/Label'

import './styles.scss'

interface Props {
  checkboxInitialValue?: boolean
  id?: string
  isCheckboxDisabled?: boolean
  label?: string
  labelPosition?: 'left' | 'top'
  onCheckboxChanged?: (checkboxValue: boolean) => void
  required?: boolean
  size: Exclude<SIZES, 'large'>
  tooltip?: ReactNode
  withCheckbox?: boolean
}

const OptionsContainer = ({
  checkboxInitialValue,
  id,
  isCheckboxDisabled,
  label,
  labelPosition = 'top',
  onCheckboxChanged,
  required,
  size,
  tooltip,
  withCheckbox,
}: Props): ReactElement => {
  return (
    <div className={classNames('options-container', size, labelPosition)}>
      {label ? (
        <Label id={id} label={label} labelPosition={labelPosition} required={required} size={size} tooltip={tooltip} />
      ) : null}
      {size !== 'small' && labelPosition !== 'left' && withCheckbox ? (
        <div className={classNames('checkbox-container', label ? 'right' : 'left')}>
          <div className="checkbox">
            <CheckboxInput
              disabled={isCheckboxDisabled}
              isChecked={checkboxInitialValue}
              onChange={(e: ChangeEvent<HTMLInputElement>) => onCheckboxChanged && onCheckboxChanged(e.target.checked)}
              size="small"
            />
          </div>
          <div className="checkbox-title">All except</div>
        </div>
      ) : null}
    </div>
  )
}

export default OptionsContainer
